import { createGlobalStyle } from 'styled-components';

export const WidgetGlobalStyles = createGlobalStyle`
    #documents-widget * {
      font-family: 'Funnel Display', Roboto, -apple-system, 'Segoe UI', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
`;
